import {
  RoleService
} from '@/services/nextshop/role.service'

import VueCookies from 'vue-cookies'

export async function getListPermissionsUser(to, from, next) {
  try {
    await RoleService.getListPermissionsUser()
    next()
  } catch (e) {
    console.log(e)
  }
  next()
}

export async function checkPackage(to, from, next) {
  const active = to.matched.some(route => route.meta.active)
  const valueActive = VueCookies.get('ACTIVE') == "true"? true : false
  if(active){
    if(valueActive){
      next()
    } else {
      next( {name:"login"} )
    }
  } else {
    next()
  }
}